<template>
  <div>
    <header class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
      <div>
        <h1 class="text-2xl font-bold">Measurements</h1>
        <p class="text-ink-soft text-sm mt-1">{{ total }} breath analyses</p>
      </div>
      <div class="relative w-full sm:w-72">
        <font-awesome-icon
          icon="search"
          class="absolute left-3 top-1/2 -translate-y-1/2 text-ink-muted"
        />
        <input
          v-model="search"
          class="input pl-9"
          type="search"
          placeholder="Search patient…"
          @input="onSearch"
        />
      </div>
    </header>

    <div class="card overflow-hidden">
      <div class="overflow-x-auto">
        <table class="table">
          <thead>
            <tr>
              <th>Patient</th>
              <th>Date</th>
              <th>Device</th>
              <th>Total VPA</th>
              <th>Validation</th>
              <th>Report</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="m in items"
              :key="m.uuid"
              class="cursor-pointer"
              @click="open(m)"
            >
              <td class="font-semibold">
                {{ m.patient.first_name }} {{ m.patient.last_name }}
                <span class="text-ink-muted font-normal">· {{ m.patient.external_patient_id }}</span>
              </td>
              <td>{{ fmtDate(m.measurement_timestamp) }}</td>
              <td>{{ m.device.name }}</td>
              <td class="font-semibold">{{ m.total_vpa == null ? '—' : m.total_vpa.toFixed(1) }}</td>
              <td><span class="pill" :class="statusPill(m.validation_status)">{{ m.validation_status || 'n/a' }}</span></td>
              <td><span class="pill" :class="statusPill(m.report_status)">{{ m.report_status }}</span></td>
              <td class="text-right text-ink-muted"><font-awesome-icon icon="chevron-right" /></td>
            </tr>
            <tr v-if="!loading && !items.length">
              <td colspan="7" class="text-center text-ink-muted py-10">No measurements found.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="loading" class="py-10 text-center text-ink-soft">
        <font-awesome-icon icon="circle-notch" spin /> Loading…
      </div>

      <!-- Pagination -->
      <div class="flex items-center justify-between px-4 py-3 border-t border-gray-50">
        <span class="text-xs text-ink-muted">Page {{ page }} of {{ pageCount }}</span>
        <div class="flex gap-2">
          <button class="btn btn-secondary btn-sm" :disabled="page <= 1" @click="go(page - 1)">
            Prev
          </button>
          <button class="btn btn-secondary btn-sm" :disabled="page >= pageCount" @click="go(page + 1)">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from 'helpers/api'
import { fmtDate, statusPill } from 'helpers/format'

export default {
  data() {
    return { items: [], total: 0, page: 1, perPage: 20, loading: true, search: '', _t: null }
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(this.total / this.perPage))
    },
  },
  created() {
    this.load()
  },
  methods: {
    fmtDate,
    statusPill,
    async load() {
      this.loading = true
      try {
        const res = await api.listMeasurements({
          page: this.page,
          perPage: this.perPage,
          search: this.search,
        })
        this.items = res.data
        this.total = res.total
      } finally {
        this.loading = false
      }
    },
    go(p) {
      this.page = p
      this.load()
    },
    onSearch() {
      clearTimeout(this._t)
      this._t = setTimeout(() => {
        this.page = 1
        this.load()
      }, 300)
    },
    open(m) {
      this.$router.push({ name: 'MeasurementDetail', params: { uuid: m.uuid } })
    },
  },
}
</script>
